import Axios, { AxiosRequestConfig } from "axios";

export interface IRequestTopic {
  id: number;
  name: string;
}

export async function currencies(config?: AxiosRequestConfig) {
  const response = await Axios.get<{ code: string }[]>(
    "/api/currencies/",
    config,
  );
  return response.data;
}

export async function getTimezones(config?: AxiosRequestConfig) {
  const response = await Axios.get("/api/timezones/", config);
  return response.data;
}

export async function getGasStrategies(config?: AxiosRequestConfig) {
  const response = await Axios.get("/api/gas-strategies/", config);
  return response.data;
}

export async function getRequestTopics(config?: AxiosRequestConfig) {
  const response = await Axios.get("/api/contact/request-topics/", config);
  return response.data;
}

export interface IRequestTopic {
  id: number;
  name: string;
}
